import Vue from "vue"
import App from "./App.vue"
import store from "./store"
import router from "./router"
import Vuesax from "vuesax"
import "vuesax/dist/vuesax.css" //Vuesax styles
import "./assets/fonts/fontawesome/css/all.css" //Vuesax styles
import "./assets/styles/bootstrap5.css" //Vuesax styles
import VueSocketIO from "vue-socket.io"
import SocketIO from "socket.io-client"

// const options = { path: "/api/v1" } //Options object to pass into SocketIO
const URI = process.env.VUE_APP_API_BASE_URL
console.log(URI)
Vue.use(
	new VueSocketIO({
		debug: true,
		connection: SocketIO(process.env.VUE_APP_SOCKET, { autoConnect: false }) //options object is Optional
	})
)
Vue.use(Vuesax, {
	// options here
})
Vue.config.productionTip = false

new Vue({
	store,
	router,

	render: (h) => h(App)
}).$mount("#app")
